import { SDKError } from '@crossnokaye/typescript-sdk/models/errors';

/**
 * Helper function for formatting error messages from SDK errors
 */
export const getQueryErrorMessage = (error: SDKError | Error): string => {
  let message: string;
  if (error instanceof SDKError) {
    message = `${error.httpMeta.response.url.split('/').pop()} failed with ${error.httpMeta.response.status}: ${error.httpMeta.response.statusText}`;
  } else {
    message = error.message;
  }
  return message;
};

// Toast handler function types
export type ErrorToastFn = (message: string, timeout?: number) => void;
export type WarningToastFn = (message: string, timeout?: number) => void;

// Toast handler placeholders (will be set by QueryProvider)
const errorToastFn: ErrorToastFn = () => {};
const warningToastFn: WarningToastFn = () => {};

/**
 * Register toast handler functions for query errors
 * TODO: Find proper behavior for queries failing.
 * https://crossnokaye.atlassian.net/browse/UX-3397
 */
export const setQueryClientToastHandlers = (
  _errorToast: ErrorToastFn,
  _warningToast: WarningToastFn
) => {};

/**
 * Show an error toast message
 */
export const onQueryError = (message: string, timeout?: number) => {
  errorToastFn('Query Failed! See Console for details.', timeout);
  console.error('Query error: ', message);
};

/**
 * Show a warning toast message
 */
export const onQueryWarning = (message: string, timeout?: number) => {
  warningToastFn(message, timeout);
  console.warn('Query warning: ', message);
};
